/**
 * Gates the advertorial's sticky CTA bar.
 *
 * Two rules, both applied on every scroll frame:
 *   1. Stay hidden until the reader has scrolled past a given reason.
 *   2. Hide again once the page footer starts entering the viewport, so the bar
 *      stops sitting on top of the policy links at the end of the page.
 *
 * Counts .mimu-adv__reason elements rather than targeting a fixed block id, so
 * reordering or renaming reasons in the theme editor cannot break the trigger.
 *
 * The footer anchor is the theme's single bare <footer> element, confirmed on the
 * rendered storefront rather than guessed — it is the first element of the footer
 * section group, so it marks the end of the page content.
 *
 * Fails OPEN on purpose. The bar ships visible in the markup and this script adds
 * the gating class itself, so if the file 404s or throws, the CTA stays on screen
 * rather than disappearing. The class is added in the same frame as the first
 * evaluation, so there is no visible flash on load.
 */
(function () {
  var bar = document.querySelector('[data-adv-sticky]');
  if (!bar) return;

  var after = parseInt(bar.getAttribute('data-adv-sticky-after'), 10);
  if (isNaN(after) || after < 0) after = 0;

  var reasons = document.querySelectorAll('.mimu-adv__reason');
  // after === 0 means "no reason gate" — the bar is shown from the top, but the
  // end-of-page rule below still applies.
  var target = after >= 1 ? reasons[after - 1] : null;

  var endMark = document.querySelector('footer');

  // Neither rule can be evaluated: leave the bar exactly as the markup shipped it.
  if (!target && !endMark) return;

  bar.classList.add('mimu-adv__sticky--gated');

  var scheduled = false;

  function evaluate() {
    scheduled = false;

    // "Past" means the reason's bottom edge has cleared the top of the viewport.
    var passed = target ? target.getBoundingClientRect().bottom <= 0 : true;

    // The bar is pinned to the bottom of the viewport, so it starts covering the
    // footer the moment the footer's top edge rises above the viewport bottom.
    var atEnd = endMark ? endMark.getBoundingClientRect().top <= window.innerHeight : false;

    bar.classList.toggle('is-shown', passed && !atEnd);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(evaluate);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  evaluate();
})();
